module.exports = __webpack_public_path__ + "img/mizhichashao.a8f6c34d.jpg";